import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { OperationEntrepriseTLR } from '../entities/operation-entreprise-tlr.entity';

@Injectable({ providedIn: 'root' })
export class OperationEntrepriseService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: OperationEntrepriseService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	public getOperationsEntreprisesByParcAndClasse(parcId: number, classeId: number): Observable<OperationEntrepriseTLR[]> {
		let url = this.path + "operations-entreprises?parc=" + parcId + "&classe=" + classeId;
		let result = this.httpClient //
			.get<OperationEntrepriseTLR[]>(url) //
		;

		return result;
	}
}